
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"11","viewBox":"0 0 12 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.512 0L5.09 1.414l3.088 3.088H0v1.996h8.177L5.089 9.586 6.512 11 12 5.5z","fill":"#3F51B5"}})])
          )
        }
      }
    